import Container from './StashLayout.container';
import StashLayout from './StashLayout';

export default Container(StashLayout);
